
const financeRouter = {
  path: '/',
  component: () => import('@/components/report/home.vue'),
  children: [
    {
      path: '/report/refund-card',
      name: 'refund-card',
      component: () => import('@/components/report/finance/refund-card.vue')
    },
    {
      path: '/report/card-balance',
      name: 'card-balance',
      component: () => import('@/components/report/finance/card-balance.vue')
    },
    // LE-3429 标准成本需求 要加一个 物料用量
    {
      path: '/report/material-usage',
      name: 'material-usage',
      component: () => import('@/components/report/finance/material-usage.vue')
    },
    //  福利卡发放
    {
      path: '/report/welfare-grant',
      name: 'welfare-grant',
      component: () => import('@/components/report/finance/welfare-grant.vue')
    },
    //  福利卡使用
    {
      path: '/report/welfare-usage',
      name: 'welfare-usage',
      component: () => import('@/components/report/finance/welfare-usage.vue')
    },
    // 卡发生额报表
    {
      path: '/report/card-transaction',
      name: 'card-transaction',
      component: () => import('@/components/report/finance/card-transaction.vue')
    },
    // 卡发生总额报表
    {
      path: '/report/card-total-transaction',
      name: '/report/card-total-transaction',
      component: () => import('@/components/report/finance/card-total-transaction.vue')
    }
  ]
}

export default financeRouter
